.ci{z-index:2;}